module.exports = __webpack_public_path__ + "static/images/gear.8TFfxZo.svg";